var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCenterMobileLinksMobileMini(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 51,
    viewBox: "0 0 34 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.77308 0.939453C3.40831 0.939453 0.636719 3.71104 0.636719 7.07582V43.894C0.636719 47.2588 3.40831 50.0304 6.77308 50.0304H27.2276C30.5924 50.0304 33.364 47.2588 33.364 43.894V7.07582C33.364 3.71104 30.5924 0.939453 27.2276 0.939453H6.77308ZM6.77308 5.03036H27.2276C28.3629 5.03036 29.2731 5.94059 29.2731 7.07582V43.894C29.2731 45.0292 28.3629 45.9395 27.2276 45.9395H6.77308C5.63786 45.9395 4.72763 45.0292 4.72763 43.894V7.07582C4.72763 5.94059 5.63786 5.03036 6.77308 5.03036ZM17.0004 39.8031C16.4579 39.8031 15.9376 40.0186 15.554 40.4022C15.1704 40.7858 14.9549 41.3061 14.9549 41.8485C14.9549 42.391 15.1704 42.9113 15.554 43.2949C15.9376 43.6785 16.4579 43.894 17.0004 43.894C17.5428 43.894 18.0631 43.6785 18.4467 43.2949C18.8303 42.9113 19.0458 42.391 19.0458 41.8485C19.0458 41.3061 18.8303 40.7858 18.4467 40.4022C18.0631 40.0186 17.5428 39.8031 17.0004 39.8031Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterMobileLinksMobileMini);
export default __webpack_public_path__ + "static/media/center-mobile-links-mobile-mini.0abfd3e22c3d99255d9e7ce6d06b7cee.svg";
export { ForwardRef as ReactComponent };